import { getAppInsights } from './TelemetryService';
import { eSeverityLevel, SeverityLevel } from '@microsoft/applicationinsights-common';
import config from '../../config';

const isDevEnvironment = (): boolean => config.environment === 'dev';

const logMessage = (message: string, severityLevel: eSeverityLevel) => {
    if (isDevEnvironment()) {
        switch (severityLevel) {
            case SeverityLevel.Critical | SeverityLevel.Error: {
                console.error(message);
                break;
            }
            case SeverityLevel.Warning: {
                console.warn(message);
                break;
            }
            default: {
                console.info(message);
                break;
            }
        }
    } else {
        const appInsights = getAppInsights();
        if (appInsights) {
            appInsights.trackTrace({ message, severityLevel });

            if (severityLevel === SeverityLevel.Critical || severityLevel === SeverityLevel.Error) {
                appInsights.trackException({ exception: new Error(message) });
            }
        }
    }
};

const logEvent = (name: string, properties: Record<string, any>) => {
    if (isDevEnvironment()) {
        console.log('Event:', { name, properties });
    } else {
        const appInsights = getAppInsights();
        if (appInsights) {
            appInsights.trackEvent({ name, properties });
        }
    }
};

export default {
    info: (message: string) => logMessage(message, SeverityLevel.Information),
    warning: (message: string) => logMessage(message, SeverityLevel.Warning),
    error: (message: string) => logMessage(message, SeverityLevel.Error),
    event: (name: string, properties: Record<string, any>) => logEvent(name, properties),
};